import {Component} from '@angular/core';
import {Block}     from "../../../block";

@Component({
    selector   : 'app-pricing-table-header',
    templateUrl: './pricing-table-header.component.html',
})
export class PricingTableHeaderComponent extends Block {
}
